export const PRODUCTIVITY_CATEGORY = {
  focus: 'Focus',
  distraction: 'Distraction',
  other: 'Other',
};

/**
 * Classifies an app's display name as Focus / Distraction / Other, using
 * the company/team focus & distraction lists (see useEffectiveProductivityApps).
 * Matching is case-insensitive, same as useFocusVsDistraction's own matching.
 *
 * There is no stored "Other" list — it's whatever isn't in either list.
 *
 * @param {string} appName
 * @param {{ focusApps?: string[], distractionApps?: string[] }} lists
 * @returns {'Focus' | 'Distraction' | 'Other'}
 */
export const classifyAppByProductivity = (
  appName,
  { focusApps = [], distractionApps = [] } = {}
) => {
  const name = (appName || '').toLowerCase();
  if (focusApps.some((app) => app.toLowerCase() === name)) {
    return PRODUCTIVITY_CATEGORY.focus;
  }
  if (distractionApps.some((app) => app.toLowerCase() === name)) {
    return PRODUCTIVITY_CATEGORY.distraction;
  }
  return PRODUCTIVITY_CATEGORY.other;
};
